<script>
/**
 * BaseSegmentedTabs — navegação "segmented" (container cinza + pílula ativa
 * branca), no estilo do design. Usada para sub-abas dentro de um submódulo.
 *
 * Layout: o segmented fica à esquerda e há um slot `actions` no FIM da linha
 * (mesma row) para botões de ação da subpágina.
 *
 * Quando usar (vs. BaseToggleButton):
 *  - BaseSegmentedTabs → NAVEGAÇÃO entre sub-abas/seções de uma página (troca de
 *    contexto/rota interna). Visual de "pílula" branca sobre faixa cinza + slot
 *    `actions` na mesma linha. É a barra de sub-navegação do guia.
 *  - BaseToggleButton → alternar um VALOR/opção dentro da mesma tela (ex.: filtro
 *    Tabela/Gráfico, Mensal/Anual) — controle de formulário, não navegação.
 *  Mantemos os dois propositalmente: papéis distintos (navegação × valor).
 *
 * Props:
 *  - value: valor selecionado.
 *  - options: [{ value, text }].
 * Emite `input`/`change` com o valor selecionado.
 */
export default {
  name: 'BaseSegmentedTabs',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleChange(value) {
      // BaseToggleButton é `mandatory`, então não reemite ao clicar no ativo.
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>

<template>
  <div class="segmented-tabs d-flex align-center justify-space-between">
    <BaseToggleButton
      class="segmented-tabs__group"
      segmented
      :value="value"
      :options="options"
      @change="handleChange"
    />

    <div class="segmented-tabs__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
// O visual "segmented" (faixa cinza + pílula ativa branca) agora vem do
// BaseToggleButton via prop `segmented` — mantém o estilo unificado num só lugar.
.segmented-tabs
  gap: 16px
  flex-wrap: wrap

  &__actions
    display: flex
    align-items: center
    gap: 8px
</style>
